import { selectCabinetId } from 'src/app/store/cabinet/cabinet.selectors';
import { CabinetState } from 'src/app/store/cabinet/cabinet.reducer';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { shareReplay } from 'rxjs/operators';
import { selectAllCabinets, selectCabinet } from 'src/app/store/cabinet/cabinet.selectors';

@Injectable({
  providedIn: 'root'
})
export class CabinetService {

  cabinets$ = this.store.select(selectAllCabinets).pipe(shareReplay(1));
  cabinet$ = this.store.select(selectCabinet).pipe(shareReplay(1));
  cabinetId$ = this.store.select(selectCabinetId).pipe(shareReplay(1));

  constructor(
    private store: Store<CabinetState>
  ) { }
}
